// extracted by mini-css-extract-plugin
export default {"tabs":"CokqF1gkLpT1lSw3E9iF","tab":"u4z0OD2QK9Fd02yNNeX_","indicator":"HQVJL9kNS9PouUBq8j0R","active":"faKSM9pkKeY05IrZARln"};